import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import BaseModal, { modalStyles, HoverButton } from './BaseModal';
import { colors, typography } from '../../styles/theme';
import ModalStickyFooter from '../ui/ModalStickyFooter';

interface ExpiredPuzzleModalProps {
  visible: boolean;
  onClose: () => void;
}

export default function ExpiredPuzzleModal({ visible, onClose }: ExpiredPuzzleModalProps) {
  return (
    <BaseModal
      visible={visible}
      onClose={onClose}
      isFullScreenOnMobile={false}
      header={<Text style={modalStyles.headerText}>Puzzle Expired</Text>}
      footer={(
        <ModalStickyFooter>
          <HoverButton
            style={modalStyles.primaryButton}
            textStyle={modalStyles.primaryButtonText}
            onPress={onClose}
          >
            Return to Main Menu
          </HoverButton>
        </ModalStickyFooter>
      )}
    >
      <View style={styles.container}>
        <Text style={styles.bodyText}>
          This custom puzzle is no longer available. To save server space, creators are limited to 5 custom puzzles at a time, and this one has been overwritten by a newer creation.
        </Text>
      </View>
    </BaseModal>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    marginBottom: 20,
    paddingHorizontal: 8,
  },
  bodyText: {
    ...typography.body,
    color: colors.textMuted,
    textAlign: 'center',
    lineHeight: 24,
  },
});
